import React from "react";

const PreorderSheet = ({
  pdfData,
  formatDueDeliveryDate,
  isVisible,
  selectedDoctor,
}) => {
  return (
    <div
      id="pre-order-sheet"
      className={`border-gray border px-12 pb-4 pt-12 m-auto rounded-3xl relative ${
        // className={`border-gray border lg:px-32 px-24 pb-16 pt-20 lg:pb-24 lg:pt-24 m-auto rounded-3xl relative ${
        !isVisible ? "hidden" : ""
      }`}
      style={{
        width: "559px", // A6 fixed width
        minHeight: "auto", // Allows height to adjust dynamically
        backgroundColor: "white",
        overflow: "hidden",
        pageBreakInside: "avoid", // Ensures no split
        breakInside: "avoid",
      }}
    >
      <div className="flex items-start justify-between gap-2 font-interBold">
        <div>
          <p className="text-2xl text-gray-600 mb-4">
            {selectedDoctor?.dentistDisplayName || "Dentist Name"}
          </p>
          <p className="text-2xl text-gray-600 mb-4">{pdfData.patientName}</p>
        </div>
        <div className="flex items-center justify-end gap-2 absolute right-8 top-8 text-gray-500">
          <p className="text-2xl text-gray-600 font-interRegular mb-0">
            Delivery Date:
          </p>
          <p className="text-2xl text-gray-600 font-interBold mb-0">
            {pdfData.deliveryDate}
          </p>
        </div>
      </div>
      <hr className="border-gray my-7"></hr>
      <div>
        <div className="flex items-center justify-between gap-2  mb-5 font-interBold">
          <p className="text-2xl text-gray-700">Due Date & Time:</p>
          <div className="flex items-center justify-between gap-2 text-2xl text-gray-600 font-interRegular">
            <p>{formatDueDeliveryDate(pdfData.dueDate)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreorderSheet;
